import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { AdminUserService, ApplicationUserApi } from 'src/app/services/admin-user.service';
import { AppropriatorsService } from 'src/app/services/appropriators.service';
import { LoadingService } from 'src/app/services/loading.service';
import { LoginService } from 'src/app/services/login.service';
import { DssValidators } from 'src/app/services/dss.validators';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  authenticated: Observable<boolean>;
  formRegister: FormGroup = null;
  formRole: FormGroup;

  allUserRoles: any[];
  allUsers: ApplicationUserApi[] = [];
  allAppropriators: any;
  selecteduser: ApplicationUserApi = null;

  newName: string;
  newUserName: string;
  newEmail: string;
  newPassword: string;
  newRoleName: string;
  registerFailure: string;
  roleCreateFailure: string;
  registerClicked = false;
  returnUrl: string;
  loading: boolean = false;
  pwInputType = "password";
  selectedUserRow: string = "";

  registerFormStatus: string = '';

  userViewSize: number = 10;
  userViewPagesTotal: number = 1;
  userViewPageIndexCurrent: number = 1;
  userViewUsers: ApplicationUserApi[] = null;
  searching: boolean;
  searchFailed: boolean;
  searchTerm: string

  updateClaimsFailure: string;
  duplicateUsername: boolean = false;

  activeLink = 1;

  private unsubscribe: Subject<any> = new Subject();

    @ViewChild('applicationuserview', { read: ViewContainerRef, static: false }) appuserview: ViewContainerRef;

  constructor(
    private modalConfig: NgbModalConfig,
    private modalService: NgbModal,
    private loginService: LoginService,
    private usersService: AdminUserService,
    private appropriatorService: AppropriatorsService,
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
  ) {
    this.authenticated = loginService.authenticated;

    this.formRegister = new FormGroup({
      registeremail: new FormControl('',[
        Validators.required,
        Validators.email
      ]),
      registerusername: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        DssValidators.hasNoSpace,
      ]),
      registerpassword: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        DssValidators.hasDigit,
        DssValidators.hasLowerCase,
        DssValidators.hasUpperCase,
        DssValidators.hasNonAlphaNumeric,
      ])
    });

    this.formRole = new FormGroup({
      name: new FormControl(),
    });

  }

 ngOnInit() {
    this.usersService.getusers();
    this.usersService.getroles();

    this.usersService.roles.pipe(takeUntil(this.unsubscribe)).subscribe(allRoles => {
      this.allUserRoles = allRoles;
      //console.log('admin.allRoles: ' + JSON.stringify(allRoles));
    });
    this.usersService.users.pipe(takeUntil(this.unsubscribe)).subscribe(allUsers => {
      this.allUsers = allUsers;
      if (!!this.allUsers) {
        //console.log('admin.getusers: ' + this.allUsers.length);
        //console.log('admin.getusers: ' + JSON.stringify(this.allUsers));
        this.userViewPagesTotal = Math.trunc(this.allUsers.length / this.userViewSize);
        if (this.allUsers.length % this.userViewSize > 0) {
          this.userViewPagesTotal += 1;
        }
        this.userViewPageIndexCurrent = 1;
        this.userViewUsers = [];
        var size = this.userViewSize;
        if (this.userViewPagesTotal == 1) {
          size = this.allUsers.length;
        }
        for (let i = 0; i < size; i++) {
          this.userViewUsers.push(this.allUsers[i]);
        }
      }
    });
    this.appropriatorService.getAppropriators();
    this.appropriatorService.currentAppropriators.pipe(takeUntil(this.unsubscribe)).subscribe(allApps => {
      this.allAppropriators = allApps;
      //console.log('admin.allapps: ' + JSON.stringify(allApps));
    });

    this.usersService.selectedUser
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(selected => {
        if (selected) {
          this.selecteduser = selected;
        }
      });

    this.loadingService.currentLoading
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(loading => {
      this.loading = loading;
    });
  }

  showuser(user: ApplicationUserApi)
  {
    this.usersService.changeSelectedUser(user);
    this.selectedUserRow = user.name;
  }

  registeruser() {
    if (this.registerHasErrors()) { return; }
    if (this.nameTaken()) {
      return;
    }

    this.registerClicked = true;
    this.newEmail = this.formRegister.get('registeremail').value;
    this.newUserName = this.formRegister.get('registerusername').value;
    this.newPassword = this.formRegister.get('registerpassword').value;
    if (!this.newEmail || !this.newPassword)
    { return;  }

    this.usersService.register(this.newUserName, this.newEmail, this.newPassword, true)
        .then(response => {
          this.registerFailure = response.failureMessage;
        });
    this.newPassword = null;
    this.registerClicked = false;
    if (!this.registerFailure) {
      setTimeout(() => {
        this.modalService.dismissAll();
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin';
        this.router.navigateByUrl(this.returnUrl);
      }, 1000);
    }
    this.clearRegisterForm();
  }

  clearRegisterForm() {
    this.formRegister.reset();
  }

  registerHasErrors() {
    var re = this.email();
    if (!!re.errors && (re.errors.required || re.errors.email)) { return true; }
    var run = this.username();
    if (!!run.errors && (run.errors.required || run.errors.minlength || run.errors.hasNoSpace )) { return true; }
    var rp = this.password();
    if (!!rp.errors && (
        rp.errors.required ||
        rp.errors.minlength ||
        rp.errors.hasDigit ||
        rp.errors.hasLowerCase ||
        rp.errors.hasUpperCase ||
        rp.errors.hasNonAlphaNumeric)) { return true; }
    return false;
  }

  nameTaken() : boolean {
    if (!this.allUsers) {
      this.duplicateUsername = false;
      return false;
    }
    var un = this.username().value;
    for (var i = 0; i < this.allUsers.length; i ++) {
      if (this.allUsers[i].name == un) {
        this.duplicateUsername = true;
        return true;
      }
    }
    this.duplicateUsername == false;
    return false;
  }

  password() {
    return this.formRegister.get('registerpassword');
  }

  email() {
    return this.formRegister.get('registeremail');
  }

  username() {
    return this.formRegister.get('registerusername');
  }

  async createrole() {
    //this.registerClicked = true;
    this.newRoleName = this.formRole.get('name').value;
    if (!this.newRoleName)
    { return;  }

    let result = await this.usersService.createrole(this.newRoleName);
    this.roleCreateFailure = result.failureMessage;
    this.newRoleName = null;
    //this.registerClicked = false;
    if (!this.roleCreateFailure) {
      setTimeout(() => {
        this.modalService.dismissAll();
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin';
        this.router.navigateByUrl(this.returnUrl);
      }, 1000);
    }
  }

  async updateUser(user: ApplicationUserApi) {
    if (!user)
    { return;  }

    let result = await this.usersService.updateuser(user);
    this.updateClaimsFailure = result.failureMessage;
    //this.registerClicked = false;
    if (!this.updateClaimsFailure) {
      setTimeout(() => {
        this.modalService.dismissAll();
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin';
        this.router.navigateByUrl(this.returnUrl);
      }, 1000);
    }
  }

  changeActiveLink(newLink: number) {
    this.activeLink = newLink;
  }

  openregister(content) {
    this.modalService.open(content, { ariaLabelledBy: 'login-modal', centered: true });
    this.registerFailure = null;
  }

  openrole(content) {
    this.modalService.open(content, { ariaLabelledBy: 'login-modal', centered: true });
    this.roleCreateFailure = null;
  }

  showPasswordToggle() {
    if (this.pwInputType === "password") {
      this.pwInputType = "text";
    } else {
      this.pwInputType = "password";
    }
  }

  prev() {
    this.userViewPageIndexCurrent -= 1;
    if (this.userViewPageIndexCurrent < 1) {
      this.userViewPageIndexCurrent = 1;
    }
    this.userViewUsers = [];
    var indexLast = this.userViewPageIndexCurrent * this.userViewSize;
    if (indexLast > this.allUsers.length) {
      indexLast = this.allUsers.length;
    }

    var indexFirst = indexLast - this.userViewSize;
    if (indexFirst < 0) {
      indexFirst = 0;
    }

    for (var i = indexFirst; i < indexLast; i++) {
      this.userViewUsers.push(this.allUsers[i]);
    }
  }

  next() {
    this.userViewPageIndexCurrent += 1;
    if (this.userViewPageIndexCurrent > this.userViewPagesTotal) {
      this.userViewPageIndexCurrent = this.userViewPagesTotal;
    }
    this.userViewUsers = [];
    var indexLast = this.userViewPageIndexCurrent * this.userViewSize;
    if (indexLast > this.allUsers.length) {
      indexLast = this.allUsers.length;
    }

    var indexFirst = indexLast - this.userViewSize;
    if (indexFirst < 0) {
      indexFirst = 0;
    }

    for (var i = indexFirst; i < indexLast; i++) {
      this.userViewUsers.push(this.allUsers[i]);
    }
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2
        ? []
        : this.allUsers.filter(u => u.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )

  onSearchChange(searchValue: any): void {
    var res = searchValue.item;
    this.showuser(res);
  }

  formatResultUser(value: any) {
    return value.name;
  }

  formatInputUser(value: any)   {
    if(value.name)
      return value.name
    return value;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
